import React from 'react';

const NO_REPORT = 'No credit report is stored on this claim.';

interface CreditReportStatusProps {
  /** False when neither this claim nor its .001 claim has a report. */
  reportAvailable?: boolean;
  /** Set when this claim has no report and the summary shows this other claim's instead. */
  reportFromClaimId?: string | null;
  /** The server's line for that case (it knows whether nothing is stored or it failed to load). */
  notice?: string | null;
  /** The server's empty-state line. */
  message?: string | null;
}

/**
 * Tells staff whose credit report the Credit Check Summary is showing.
 *
 * A claim with no stored report falls back to the client's .001 claim. That is
 * usually the same credit file, but staff were comparing this claim's
 * agreement number with another claim's report without knowing it.
 */
const CreditReportStatus: React.FC<CreditReportStatusProps> = ({ reportAvailable, reportFromClaimId, notice, message }) => {
  if (reportAvailable === false) {
    return (
      <div
        role="status"
        style={{
          // Full width and top-aligned: the shared .modal-body is a flex row.
          width: '100%', boxSizing: 'border-box', alignSelf: 'flex-start',
          padding: '24px 20px', margin: '8px 0', borderRadius: 8, textAlign: 'center',
          background: '#f5f5f5', border: '1px solid #ddd', color: '#444', fontSize: 16, fontWeight: 600,
        }}
      >
        {message || NO_REPORT}
      </div>
    );
  }

  if (reportFromClaimId) {
    return (
      <div
        role="status"
        style={{
          padding: '12px 16px', marginBottom: 16, borderRadius: 8,
          background: '#fff3cd', border: '1px solid #f0ad4e', color: '#7d5a00', fontWeight: 600,
        }}
      >
        {notice || `${NO_REPORT} Showing the report from ${reportFromClaimId}.`}
      </div>
    );
  }

  return null;
};

export default CreditReportStatus;
